'use strict';

import jQuery from 'jquery';
import cookie from './../../vendor/jquery.cookie';
import Promise from 'native-promise-only';
import flag from '../Feature/Feature.js';

const FETCH_INTERVAL = 60 * 1000;

function refreshAccountInformation() {
  let key = 'account_fetch';

  try {
    let lastFetch = JSON.parse(window.localStorage.getItem(key));

    if (lastFetch === null || lastFetch.result === false || (lastFetch.updated_at + FETCH_INTERVAL) < Date.now()) {
      return jQuery.ajax({
        url: '/refresh-account/',
        type: 'POST',
        xhrFields: {
          withCredentials: true
        },
        dataType: 'text',
      }).then(function() {
        window.localStorage.setItem(key, JSON.stringify({result: true, updated_at: Date.now()}));
        return true;
      }).catch(function() {
        window.localStorage.setItem(key, JSON.stringify({result: false, updated_at: Date.now()}));
        return false;
      });
    }
  } catch (err) {
    window.localStorage.setItem(key, JSON.stringify({result: false, updated_at: Date.now()}));
    return Promise.resolve(false);
  }

  return Promise.resolve(true);
}

var PassportUser = (function($) {
  return function (options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    privateNS.init = function init() {

      // Default the user to null
      privateNS.user = null;

      // Create a default value for how often validation should occur
      privateNS.validationInterval = 0;

      // Create a holder for the scheduled validation process
      privateNS.validationIntervalId = null;

      // Store callbacks for should be triggered after a refresh
      privateNS.onRefreshHandlers = [];

      // Try to load in the passport cookie of the user
      privateNS.loadFromCookie();

      return publicNS;
    };

    privateNS.loadFromCookie = function loadFromCookie() {

      // Try to load in the passport cookie of the user
      var userAccessCookieData = $.cookie('passport_access');

      // If the cookie exist it we can try to parse it
      if (userAccessCookieData) {

        // Decode the contents to get it back to proper JSON syntax
        var decodedUserAccessData = decodeURIComponent(userAccessCookieData);

        // If the cookie was successfully decoded, try to parse it
        if (decodedUserAccessData) {

          // Attempt to parse the contents
          try {

            // Try to parse the decoded data as JSON and store it as the
            // internal user state
            privateNS.user = JSON.parse(decodedUserAccessData);
          } catch (e) {

            // If the parse failed with an exception, there is nothing that
            // can be done
          }
        }
      }
    };

    /**
     * Attempts to extract the unique user auth uuid from the users state
     *
     * @returns {string} The auth uuid of the user if it exists, or empty string if
     *                   the auth uuid is not defined
     */
    publicNS.getUuid = function getUuid() {

      // Check to see if the uid exists before returning it
      if (privateNS.user && privateNS.user.uuid) {
        return privateNS.user.uuid;
      }

      return '';
    };

    /**
     * Attempts to extract the unique user id from the users state
     *
     * @returns {string} The id of the user if it exists, or empty string if
     *                   the user id is not defined
     */
    publicNS.getUid = function getUid() {

      // Check to see if the uid exists before returning it
      if (privateNS.user &&
          privateNS.user.pbs_profile &&
          privateNS.user.pbs_profile.UID) {
        return privateNS.user.pbs_profile.UID;
      }

      return '';
    };

    /**
     * Attempts to extract the user access level from the users state
     *
     * @returns {number} The access level of the user. Defaults to 0 if none is
     *                   defined for the user
     */
    publicNS.getAccessLevel = function getAccessLevel() {

      // Check to see if the access level exists before returning it
      if (privateNS.user && privateNS.user.access_level) {
        return privateNS.user.access_level;
      }

      return 0;
    };

    /**
     * Attempts to extract the string representation of the user access level
     * from the users state
     *
     * @returns {number} The access level of the user. Defaults to 'public' if
     *                   none is defined for the user
     */
    publicNS.getAccessLevelKey = function getAccessLevelKey() {

      // Check to see if the access level exists before returning it
      if (privateNS.user && privateNS.user.access_level) {
        if (privateNS.user.access_level === 1) {
          return 'all_members';
        } else if (privateNS.user.access_level === 2) {
          return 'station_members';
        }
      }

      return 'public';
    };

    /**
     * Checks the user state and returns true if the user has a state (signed in)
     * or false if the user does not (signed out)
     *
     * @returns {boolean} True if the user is signed in, false if the user is not
     */
    publicNS.isSignedIn = function isSignedIn() {
      return !!privateNS.user;
    };

    /**
     * Checks to see the grace period of the user state has expired
     *
     * @returns {boolean}
     */
    publicNS.isExpired = function isExpired() {
      return publicNS.isSignedIn() &&
        !!privateNS.user.grace_period &&
        new Date(privateNS.user.grace_period * 1000 || "").getTime() < Date.now();
    };

    /**
     * Returns true if the user has accepted the VPPA agreement, and false if
     * they have not accepted, declined to accept, or expired
     *
     * @returns {boolean}
     */
    publicNS.hasAcceptedVPPA = function hasAcceptedVPPA() {
      return privateNS.user && privateNS.user.vppa &&
        privateNS.user.vppa === true;
    };

    /**
     * Returns the passport status of the user. This can not check for users
     * that are eligible for Passport but have not activated as that requires
     * more information than what is stored in the users cookie
     *
     * @returns {string}
     */
    publicNS.getPassportStatus = function getPassportStatus() {
      let passportStatus = 'UNKNOWN';

      if (!publicNS.hasAcceptedVPPA()) {
        passportStatus = 'TERMS';
      } else if (publicNS.isExpired()) {
        passportStatus = 'EXPIRED';
      } else if (publicNS.getAccessLevel() > 0) {
        passportStatus = 'ACTIVE';
      } else if (publicNS.getAccessLevel() === 0) {
        passportStatus = 'INELIGIBLE';
      }

      return passportStatus;
    };

    /**
     * Fires off an Ajax request to the server over HTTPS to re-validate the
     * user's state.
     */
    publicNS.revalidate = function revalidate() {
      if (flag('use_id_service')) {
        if (publicNS.isSignedIn()) {
          $.ajax({
            url: '/refresh/',
            type: 'POST',
            xhrFields: {
              withCredentials: true
            },
            dataType: 'text',
          })
          .then(privateNS.loadFromCookie)
          .then(refreshAccountInformation)
          .then(success => {
            privateNS.onRefreshHandlers.forEach(handler => {
              handler(success);
            });
          });
        }
      } else {

        // Define an endpoint
        var endpoint = window.themosis && window.themosis.ajaxurl ? window.themosis.ajaxurl.replace(/^https?/, 'https') : '';

        if (endpoint) {

          // Ask for re-validation of the current user
          $.ajax({
            url: endpoint, // Global access to the WordPress ajax handler file
            type: 'POST',
            xhrFields: {
              withCredentials: true
            },
            dataType: 'text',
            data: {
              action: 'Passport.revalidate'
            }
          }).then(privateNS.loadFromCookie);
        }
      }
    };

    /**
     * Install scheduled revalidation of the users credentials to assist in
     * timing out users after they are inactive for a certain duration
     *
     * @param {number} interval The interval to run the revalidation at in
     *                          milliseconds
     */
    publicNS.revalidateOnInterval = function revalidateOnInterval(interval) {

      // Trigger an initial re-validation of the user's current session
      publicNS.revalidate();

      // Before scheduling anything make sure that there is not already a
      // scheduled validation occurring. If there is one, end it
      if (privateNS.validationIntervalId === null) {

        // End the currently running validation
        clearInterval(privateNS.validationIntervalId);

        // Remove the previously tracked interval id
        privateNS.validationIntervalId = null;
      }

      // Set up a function to run the validation function at the passed in
      // interval and save back the id
      privateNS.validationIntervalId = setInterval(
        function scheduledValidation() {

          // Trigger a re-validation
          publicNS.revalidate();
        },
        interval
      );
    };

    /**
     * Register an arbitrary function as a refresh handler
     */
    publicNS.registerRefreshHandler = function registerRefreshHandler(fn) {
      privateNS.onRefreshHandlers.push(fn);
    }

    return privateNS.init();
  };
})(jQuery);

export default PassportUser